<template>
  <div class="container-fluid">
    <personal-profile-cdc-module
        v-if="ready"
        :person="this.person" />
  </div>
</template>

<script>
import PersonalProfileCdcModule from "./PersonalProfileCdcModule";
export default {
  name: "PersonalProfile",
  components: {PersonalProfileCdcModule},
  data: () => ({
    ready: false,
    rfc: '',
    person: null
  }),
  async mounted() {
    let personalProfileId = this.$route.params.id;

    try {
      const {data} = await axios.get(`/api/personal-profile/${personalProfileId}`)
      this.person = data;
      this.rfc = data.rfc;
    } catch (e) {
      // show error
    } finally {
      this.ready = true;
    }

  }
}
</script>

<style scoped>

</style>
